var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2480.000000pt",
    height: "3508.000000pt",
    viewBox: "0 0 2480.000000 3508.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,3508.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8707 29904 c-208 -37 -383 -129 -532 -279 -130 -129 -215 -276 -263 -454 -26 -96 -26 -98 -30 -553 l-3 -458 -1458 0 c-1261 0 -1470 -2 -1546 -15 -215 -38 -388 -127 -540 -280 -129 -129 -214 -275 -264 -454 l-26 -96 0 -6255 0 -6255 26 -96 c50 -179 135 -325 264 -454 152 -153 325 -242 540 -280 78 -13 850 -15 6945 -15 6095 0 6867 2 6945 15 215 38 388 127 540 280 130 129 215 276 263 454 26 96 26 98 30 554 l3 457 1458 0 c1261 0 1470 2 1546 15 215 38 388 127 540 280 129 129 214 275 264 454 l26 96 0 6255 0 6255 -26 96 c-50 179 -135 325 -264 454 -152 153 -325 242 -540 280 -78 13 -849 15 -6954 14 -5846 -1 -6878 -3 -6944 -15z m13233 -7084 l0 -5600 -1170 0 -1170 0 -2 5048 -3 5047 -26 96 c-50 179 -135 325 -264 454 -152 153 -325 242 -540 280 -78 13 -619 15 -4736 15 l-4649 0 0 130 0 130 6280 0 6280 0 0 -5600z m-3840 -1760 l0 -5600 -6280 0 -6280 0 0 5600 0 5600 6280 0 6280 0 0 -5600z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.38ec5b8d7869d28231ce03854e553b73.svg";
export { ForwardRef as ReactComponent };